import React from 'react';
import styles from '../Navbar.module.css';

const SacuvaniPretrageIkonica = (props) => (
 <svg className={styles.sadrzajMainDugmeIkonica} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.8428 25.7094L15.006 20.3425L8.16925 25.7094C7.2918 26.4062 6 25.7705 6 24.6458V7.68953C6 6.19806 7.20649 5 8.6811 5H21.3188C22.8056 5 23.9999 6.21029 23.9999 7.68953V24.6458C24.0121 25.7705 22.7325 26.4062 21.8428 25.7094Z" fill="#1070D1"/>
</svg>
);

export default SacuvaniPretrageIkonica;